import PoliciesPage from './policiesPage';
export default PoliciesPage;
